<script setup lang="ts">
import DataTable from 'primevue/datatable';
import Column from 'primevue/column';
import Button from 'primevue/button';
import IconField from 'primevue/iconfield';
import InputIcon from 'primevue/inputicon';
import InputText from 'primevue/inputtext';

import { useSearchClients } from '../composables/useSearchClients';

import { useClientFileHandler } from '../composables/useClientFileHandler';

import JsonUpload from '../components/JsonUpload.vue';
import ClientDeleteButton from '../components/ClientDeleteButton.vue';

const { search, searchedClients } = useSearchClients();

const { isLoading, addClientFromFile } = useClientFileHandler();
</script>

<template>
  <div class="space-y-6 py-9">
    <div class="flex items-center gap-4">
      <h1 class="mr-auto font-lora text-3xl text-gray-900">Lista moich klientów</h1>

      <IconField class="w-[430px]">
        <InputIcon class="pi pi-search" />
        <InputText class="w-[430px]" v-model="search" placeholder="Szukaj" />
      </IconField>

      <RouterLink :to="`/${$route.params.calculatorId}/client/new`">
        <Button size="small">
          <i class="pi pi-user-plus"></i>
          Nowy klient
        </Button>
      </RouterLink>

      <JsonUpload chooseLabel="Dodaj z pliku" :isLoading="isLoading" @update="addClientFromFile" />
    </div>

    <DataTable
      class="overflow-hidden rounded-xl border border-gray-200 [&__.p-row-odd]:bg-gray-50"
      :value="searchedClients"
      :rowClass="(data: any) => [{ '!bg-red-100': data.outdated }]"
      dataKey="uuid"
      removableSort
      tableStyle="min-width: 50rem"
    >
      <Column field="owner.email" header="DTH" :sortable="true" style="width: 20%">
        <template #body="{ data }">{{
          data.owner ? `${data.owner.first_name ?? ''} ${data.owner.last_name ?? ''}`.trim() || '—' : '—'
        }}</template>
      </Column>
      <Column header="Imię i nazwisko" style="width: 20%">
        <template #body="{ data }"> {{ data.first_name }} {{ data.last_name }} </template>
      </Column>
      <Column field="email" header="Adres e-mail" sortable style="width: 20%"></Column>
      <Column field="province" header="Województwo" sortable style="width: 20%"></Column>
      <Column field="phone" header="Numer telefonu" sortable style="width: 20%"></Column>
      <Column header="">
        <template #body="{ data }">
          <div class="flex gap-4">
            <RouterLink :to="`/${$route.params.calculatorId}/client/${data.uuid}`">
              <Button class="!p-2" size="small" severity="secondary" outlined>
                <i class="pi pi-pen-to-square"></i>
              </Button>
            </RouterLink>

            <ClientDeleteButton v-if="data.id" :clientId="data.id" />
          </div>
        </template>
      </Column>
    </DataTable>
  </div>
</template>
